import { useState } from 'react';
import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';

import { Form } from '@/components/ui/form';
import { formSchema } from '../_validator';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle
} from '@/components/ui/dialog';

import SpinnerButton from '@/components/common/SpinnerButton';
import Error from '@/components/common/Error';
import FormGeneral from './common/FormGeneral';
import { usePutTax, useTaxes } from '@/data/tax';

const EditTaxDialog = ({ tax, setOpen }) => {
  const [apiError, setApiError] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const putTax = usePutTax();
  const taxes = useTaxes();
  const form = useForm({
    resolver: zodResolver(formSchema),
    defaultValues: {
      name: tax.name,
      label: tax.label,
      rate: (tax.rate / 100).toString()
    }
  });

  const onSubmit = async (values) => {
    try {
      setSubmitting(true);
      setApiError('');
      const payload = {
        name: values.name,
        label: values.label,
        rate: Math.round(parseFloat(values.rate) * 100)
      };
      const updatedTax = await putTax(tax.id, payload);
      await taxes.mutate(
        (currentTaxes) =>
          currentTaxes.map((t) => (t.id === tax.id ? updatedTax : t)),
        false
      );
      setSubmitting(false);
      setOpen(false);
    } catch (err) {
      setApiError(err.message);
      setSubmitting(false);
    }
  };

  return (
    <Dialog open={true} onOpenChange={setOpen}>
      <DialogContent className="w-[600px]">
        <DialogHeader>
          <DialogTitle>Edit {tax.name} Tax</DialogTitle>
          <DialogDescription>Edit existing tax rate</DialogDescription>
        </DialogHeader>
        <Form {...form}>
          <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-4">
            <FormGeneral />
            {apiError && <Error error={apiError} />}
            <DialogFooter>
              <SpinnerButton loading={submitting}>Save</SpinnerButton>
            </DialogFooter>
          </form>
        </Form>
      </DialogContent>
    </Dialog>
  );
};

export default EditTaxDialog;
